export { default } from './ReportProduct';